module.exports = __webpack_public_path__ + "img/black.f7f786cb.png";